import { UrlProvider } from 'urls'

import routeWithLayout from 'components/auth/routeWithLayout'
import Account from 'views/auth/Account'
import Login from 'views/auth/Login'
import LoginMfa from 'views/auth/LoginMfa'

export default [
  routeWithLayout({ auth: false, drawer: false, main: Login, path: UrlProvider.getRawUrl('login') }),
  routeWithLayout({ auth: false, drawer: false, main: LoginMfa, path: UrlProvider.getRawUrl('login.mfa') }),
  routeWithLayout({ main: Account, path: UrlProvider.getRawUrl('account') }),
]
